import { BsSearch } from "react-icons/bs";
import Avatar from "react-avatar";
import styled from "styled-components";

// main container

export const AdminLayoutWrapper = styled.main`
  background-color: var(--primaryWhiteMain);
  display: flex;
  max-height: 100vh;
`;
interface SideBarProps {
  // show: boolean;
  expanded?: boolean;
}
// sidebar container
export const SideBar = styled.aside.attrs({
  className: "lg:px-7 md:px-7 sm:px-5 xs:px-5 py-7",
})<SideBarProps>`
  background: #3d0052;
  // width:100%;
  display: flex;
  min-height: 100vh;
  height: 100%;
  flex-direction: column;
  /* justify-content: space-between;
  align-items: flex-start; */
  font-family: Plus Jakarta Sans;
  /* width: 320px; */
  /* width: ${(props) => (props.expanded ? "5rem" : "320px")};
  transform: ${(props) =>
    props.expanded ? "translateX(-200px)" : "translateX(0)"};
  transition: all 0.5s ease;
  overflow: hidden; */
  @media screen and (max-width: 1300px) and (min-width: 769px) {
    /* width: 280px; */
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

// sidebar content
// maincontent container
export const MainContent = styled.section`
  // background: var(--primaryWhiteMain);
  flex: 1;
  padding: 3rem;
  max-height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  @media screen and (max-width: 500px) {
    padding: 3rem 1rem;
  }
`;
export const FirstSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* width: 100%; */
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const SecondSideContainer = styled.div`
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
// ===============
// logo container
export const LogoContainer = styled.div`
  display: flex;
  /* padding-left: 3rem; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 10px;

  @media screen and (min-width: 901px) {
    position: relative;
  }
`;
interface LogoIconContainerProps {
  onClick?: () => void;
}
export const LogoIconContainer = styled.div<LogoIconContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
// logo
export const Logo = styled.img`
  width: 38px;
  /* margin-right: 0.5rem; */
`;
export const LogoIcon = styled.img`
  width: 20px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const LogoText = styled.img`
  width: 100%;
  cursor: pointer;
  @media screen and (min-width: 901px) {
    position: absolute;
    left: 37px;
    top: -8px;
  }
`;
// end of logo container
// close icon
export const CloseIcon = styled.i`
  display: none;
  /* @media screen and (max-width: 1200px) {
    display: block;
    color: #fff;
    font-size: 2.8rem;
  } */
  @media screen and (max-width: 768px) {
    display: block;
    color: #fff;
    font-size: 2.8rem;
  }
`;
// =====================
// first menu container
export const FirstMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: flex-start; */
  /* width: 100%; */
`;
export const ReportIncidentBtnContainer = styled.div`
  margin: 15px 0;
  width: 100%;
  padding-left: 10px;
`;
export const ReportIncidentBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 100%; */
  height: 3rem;
  color: #ffffff;
  border: 2px solid #b580ff;
  border-radius: 0.5rem;
  background: none;
  cursor: pointer;
`;
export const ReportIncidentBtnIcon = styled.img`
  width: 1.5rem;
  margin-right: 0.5rem;
`;
export const FirstMenuListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
export const FirstMenuListItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;
interface menuListItemProps {
  icon?: string;
  text?: string;
  active?: boolean;
}
export const FirstMenuListItem = styled.div<menuListItemProps>``;
export const MenuItemIcon = styled.img`
  width: 18px;
  margin-right: 0.9375rem;
`;
// end of first menu container
// =====================
// second menu container
export const SecondMenuContainer = styled.div`
  margin-top: 2.5rem;
  /* width: inherit; */
`;
export const SecondMenuListItemsContainer = styled.div``;
export const SecondMenuListItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

export const SecondMenuListItem = styled.a`
  color: ${(props) => (props.children === "SUPPORT" ? "#A1A1AA" : "#ffffff")};
  color: #a1a1aa;
  margin-bottom: ${(props) =>
    props.children === "SUPPORT" ? "1.4375rem" : "1.25rem"};
  display: flex;
  justify-content: ${(props: any) =>
    props.children === "SUPPORT" ? "flex-start" : "center"};
  align-items: center;
  width: 100%;
  margin: 20px 0;
  margin-left: ${(props) => (props.children === "SUPPORT" ? "20px" : "0")};

  /* padding-left: 3rem; */
`;
// end of second menu container
// =====================
// third menu container
export const ThirdMenuContainer = styled.div`
  margin-top: 8.5rem;
`;
export const ThirdMenuListItemsContainer = styled.div``;
export const ThirdMenuListItems = styled.div`
  width: 200px;
`;

// props for third menu list item
interface ThirdMenuListItemProps {
  function?: string;
}

export const ThirdMenuListItem = styled.div<ThirdMenuListItemProps>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 3rem;
  margin-left: 20px;
  color: #fff;
  /* padding-left: 3rem; */
`;
// end of third menu container
// =====================

// end of sidebar content
// =====================

// maincontent content
// header container
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  @media screen and (max-width: 768px) {
    display: flex;
    justify-content: space-around;
    justify-content: space-between;
  }
`;

// search container
export const SearchBarContainer = styled.div.attrs({
  className: "text-sm",
})`
  width: 70%;
  display: flex;
  position: relative;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
// end of search container
interface SearchbarProps {
  show?: boolean;
}
// search input
export const SearchBar = styled.input.attrs({
  className: "rounded",
})<SearchbarProps>`
  width: 100%;
  text-indent: 2.8125rem;
  outline: none;
  border: 1px solid #e4e4e7;
  background: #fbf8fc;
  background-color: #fff;
  height: 3rem;
  display: ${(props) => (props.show ? "block" : "none")};
`;
// end of search input
// search icon
export const SearchIcon = styled(BsSearch)<SearchbarProps>`
  position: absolute;
  left: 0.9375rem;
  top: 12px;
  width: 1.125rem;
  display: ${(props) => (props.show ? "block" : "none")};
`;
// end of search icon
// =====================
// search and nav burger container
export const NotificationAndNavBurgerContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin-left: 1rem;
  @media screen and (max-width: 1024px) {
    width: 20%;
  }
`;
// Notification container
export const NotificationandAvatarContainer = styled.div`
  width: 30%;
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media screen and(min-width: 769px) {
    width: 50%;
  }
  @media screen and (max-width: 768px) {
    /* margin: 0 5px; */
    justify-content: center;
    width: 50%;
    width: 20%;
    margin-left: 10px;
    margin: auto 0;
  }
  z-index: 1001;
`;
// mail Notification
export const MailNotificationIcon = styled.img``;
// end of mail Notification
export const BellandAvatarContainer = styled.div`
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  position: relative;
  margin-left: 5px;
  /* width: 30%; */
  @media screen and (max-width: 768px) {
    width: 50%;
  }
`;
interface DropDownContainerProps {
  show?: boolean;
  where?: string;
}

export const DropDownContainer = styled.div<DropDownContainerProps>`
  background-color: ${(props) =>
    props.where === "/user/dashboard" ? "whitesmoke" : "#fff"};
  position: absolute;
  right: 5px;
  top: 41px;
  width: 110px;
  display: ${(props) => (props.show ? "block" : "none")};
  @media screen and (max-width: 595px) {
    right: -4px;
  }
`;
export const DropDown = styled.ul`
  padding: 0;
  margin: 0;
`;
export const DropDownItem = styled.a`
  list-style-type: none;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  background-color: #fff;
  color: #3d0052;
  border: 1px solid #3d0052;
  :hover {
    background-color: #3d0052;
    color: #fff;
    border: none;
    transform: scale(1);
  }

  margin: 5px 0;
`;
// bell Notification
export const BellNotificationIcon = styled.img`
  width: 2rem;
`;
// end of bell Notification
// avatar
// export const Avatar = styled.img`;
//   width: 2rem;
// `;
// end of avatar
// end of Notification container
// end of header container
// current content container
export const CurrentContentContainer = styled.section``;
// end of maincontent container
// =====================
interface StyledNavProps {
  fromIncident?: boolean;
}
export const NavBurger = styled.div<StyledNavProps>`
  display: none;
  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 40px;
    cursor: pointer;
    /* margin: 0 15px; */
    margin-right: 15px;
    margin-bottom: ${(prop) => (prop.fromIncident ? "20px" : "0")};
  }
`;
//nav lines
export const NavBurgerLine = styled.div`
  width: 100%;
  height: 4px;
  background: #e4e4e7;
  margin: 1.3px 0;
  background-color: #3d0052;
`;
// props for styled avatar
interface StyledAvatarProps {
  src?: string;
  name?: string;
  size?: string;
  round?: string;
}
// styled avatar
export const StyledAvatar = styled(Avatar)<StyledAvatarProps>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  max-width: 35px !important;
  max-height: 35px !important;
  cursor: pointer;
`;

export const SidebarContainer = styled.div`
  @media screen and (max-width: 901px) {
    display: none;
  }
`;
